<template>
  <mt-popup v-model="moduleState.imageLibraryPreview" :modal=false popup-transition="popup-fade" class="page-module">
    <app-header v-bind="headerConfig"></app-header>

    <ul class="tabs clearfix">
      <li v-for="(item, $index) in previewData.rs_data" class="option" :class="{'act': previewIndex === $index}"
          @click="chapterSelect(item, $index)">
        <img :src="getSrc(item)">
      </li>
    </ul>

    <a href="javascript:;" class="use-btn" @click="use(selectItem)">使用该素材</a>

    <div class="main">
      <div class="ma-content">
        <img :src="getSrc(selectItem)">
        <p class="ma-name" v-text="selectItem.file_name"></p>
      </div>
    </div>
  </mt-popup>
</template>

<script>
  import {mapState} from 'vuex'
  import store from '../store/store'
  import {GameData} from '../store/GameData'
  import AppHeader from '../components/header'
  import {ComponentName, Methods, CdnLibrary} from '../const/common'

  export default {
    name: 'image_preview',
    components: {
      'app-header': AppHeader
    },
    store,
    computed: {
      ...mapState(['useRole', 'moduleState', 'openMaLibAffair']),
    },
    props: ['src', 'name'],
    data() {
      return {
        headerConfig: {
          title: '预览',
          isStoryMenu: false,
          backNote: store.state.nextPageHeaderConf.maLibPreview.backNote,
          backPage: store.state.nextPageHeaderConf.maLibPreview.backPage,
          closeModule: ComponentName.IMAGE_PREVIEW
        },
        previewIndex: 0,
        cdnLibrary: CdnLibrary,
        previewData: store.state.previewData,
        selectItem: store.state.previewData.rs_data[0],
      }
    },
    methods: {
      chapterSelect(item, index) {
        this.selectItem = item;
        this.previewIndex = index;
        Methods.checkChapterHash(79);
      },
      getSrc(item) {
        return this.cdnLibrary.CDNRES + item.rs_url.substr(0, 2) + '/' + item.rs_url;
      },
      getName(item) {
        return item.file_name;
      },
      insertEvent(item, refresh) {
        let _bgName = GameData.setChapterConfig({bg: item}).bg_name;

        GameData.AddEvent("event_change_bg", [_bgName]);
        if (refresh) {
          store.state.openMaLibCallBack(_bgName);
        }
      },
      use(item) {
        switch (this.openMaLibAffair) {
          case 'insert':
            this.insertEvent(item, false);
            Methods.checkChapterHash(31);
            break;
          case 'changeInsert':
            this.insertEvent(item, true);
            Methods.checkChapterHash(78);
            break;
          default:
            store.state.chapterConfig.bg = item;
            if (!store.state.changeChapterMedia) {
              Methods.cutComponent([ComponentName.CHAPTER_SET], true);
            }
            Methods.checkChapterHash(77);
        }
        Methods.cutComponent([ComponentName.IMAGE_PREVIEW, ComponentName.IMAGE_LIBRARY], false);
      }
    }
  }
</script>

<style scoped>
  @import "../style/css/image_preview.css";
</style>



// WEBPACK FOOTER //
// src/components/image_preview.vue